export default __webpack_public_path__ + "static/banner-6-d1cc168309bb264ffc23895b905c33c4.jpg";